import { Component, OnInit, Input } from '@angular/core';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dish-confirmation',
  templateUrl: './dish-confirmation.component.html',
  styleUrl: './dish-confirmation.component.css'
})
export class DishConfirmationComponent {
  @Input() fullData: any;

  pin: any;
  enteredPin: any;
  email: string = '';
  codeSent = false;
  resendCooldown = 0;
  resendInterval: any = null;
  currentUser: any;

  loadingId: any;
  confirmBtn: boolean = false;

  constructor(
    private data: DataserviceService,
    private router: Router,
    private message: NzMessageService
  ) { }


  ngOnInit() { 
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  }

  sendCode() {
    if (this.resendCooldown > 0) return;
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Sending Pin...', { nzDuration: 0 }).messageId;
    this.pin = Math.floor(Math.random() * 9000) + 1000;
    this.data.postDataNoBodyDotBody(
      {
        woId: this.fullData.woId,
        pin: this.pin,
        email: this.email,
        id: this.fullData.customerId,
        generic: {
          confirmationPin: this.pin,
          sentTo: this.email
        },
        fullData: this.fullData
      },
      'work-order/textPin'
    ).subscribe((r: any) => {
      console.log(r);
      this.codeSent = true;
      setTimeout(() => {
        this.message.remove(this.loadingId)
      }, 500)
      this.startResendCooldown();
    });
  }

  startResendCooldown() {
    this.resendCooldown = 60; // seconds
    this.resendInterval = setInterval(() => {
      this.resendCooldown--;
      if (this.resendCooldown <= 0) {
        clearInterval(this.resendInterval);
      }
    }, 1000);
  }

  submit() {
    console.log('hit submit')
    this.confirmBtn = true;
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Finalizing order...', { nzDuration: 0 }).messageId;
    this.data.postDataNoBodyDotBody(
      {
        woId: this.fullData.woId,
        pin: this.enteredPin,
        id: this.fullData.customerId
      },
      'work-order/confirm-pin'
    ).subscribe((r: any) => {
      console.log('confirm pin')
      this.fullData.email = this.email;
      this.fullData.cardType = 'QUAL';
      this.fullData.cardNumber = this.fullData.creditCard.creditInfo.cardNum;
      this.fullData.expiration = this.fullData.creditCard.creditInfo.expDate;
      this.fullData.addressLine1 = this.fullData.address || this.fullData?.customerInfo.address;
      this.fullData.first = this.fullData.firstName || this.fullData?.customerInfo.firstName;
      this.fullData.last = this.fullData.lastName || this.fullData?.customerInfo.lastName;
      this.fullData.cvv = this.fullData.creditCard.creditInfo.cvv;
      if (r.result == 'success') {
        console.log('CALLING CREATE CUSTOMER')
        this.data.postDataNoBodyDotBody(this.fullData, 'dish/createCustomer').subscribe((r2: any) => {
          console.log('r2 below');
          console.log(r2);
          if (r2.result == 'success') {
            alert('Order Successfully Processed! Your Order Number Is: ' + r2.data);
            //route home
            setTimeout(() => {
              this.confirmBtn = false;
              this.message.remove(this.loadingId)
            }, 500)
            this.goHome();
          }else {
            this.confirmBtn = false;
            this.message.remove(this.loadingId)
            console.log('R2 in the else: ', r2)
            let msg = r2?.message || 'We were unable to finalize your order. Please verify that all order information is correct and try again, or contact Claims for assistance.'
            alert(msg);
          }
        })
      } else {
        this.confirmBtn = false;
        this.message.remove(this.loadingId)
        const errMsg = r?.message || 'Incorrect Pin';
        alert(errMsg);
      }
    })
  }

  goHome() {
    this.router.navigate(['/home'])
  }
  
  
}
